const namespace = 'accountDetails' as const;
export default namespace;
